const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  regionSelected: state => (state.region && state.region.selected) || [],
  regionParams: state => {
    const sel = (state.region && state.region.selected) || []
    const params = {}
    if (sel.length >= 1) params.province = sel[0]
    if (sel.length >= 2) params.city = sel[1]
    return params
  },
  regionScopeLabel: state => {
    const sel = (state.region && state.region.selected) || []
    return sel.length === 0 ? '全部' : sel.join(' / ')
  }
}
export default getters
